import { connect } from 'react-redux'
import termsCondition from './termsCondition'
const mapStoreToProps = state => ({
})
const mapDispatchToProps = dispatch => ({
  // applyFilters:(filter_string)=>dispatch(applyFilters(filter_string))
})

export default connect(mapStoreToProps, mapDispatchToProps)(termsCondition)